import React from "react"
import CreateManualGmp from "../../../features/GmpManualAccount/Component/CreateManualGmp";

const CreateManualAccount = (props) => {
  return (
    <div>
      <CreateManualGmp />
    </div>
  )
};

export default CreateManualAccount;
